import React from 'react';
import links from '../../../config/links';

const SupportLink = (props) => {
    const supportLink = links.support;
    return (
        <a href={supportLink} target="_blank" rel="noopener noreferrer">{props.children}</a>
    );
};

export default SupportLink;
